import BasketResourceModel from '../../generated/types/model/resource/BasketResourceModel';

export default class BasketResourceViewModel extends BasketResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
